import React, { useCallback } from "react";

import * as strings from "../../../strings";
import * as UserActions from "../../../store/User/User.action";
import * as SupportUtils from "../../../lib/util/SupportUtils";
import * as ErrorUtils from "../../../lib/util/ErrorUtils";

import ErrorPanel from "../../common/ErrorPanel/ErrorPanel";
import Text from "../../common/Text/Text";
import Link from "../../nav/Link/Link";
import { IconBrightMileLogo, MiscBackgroundAsset } from "../../../assets";
import { isUserLoggedIn } from "../../../lib/util/AuthUtils";
import { useDispatch } from "../../../lib/hook/ReduxHooks";

export interface FatalErrorProps {
	error: Error | null;
}

const FatalError = (props: FatalErrorProps) => {
	const dispatch = useDispatch();

	const signOut = useCallback(() => {
		dispatch(UserActions.signOut());
	}, [dispatch]);

	const { error } = props;
	const identifier = error ? ErrorUtils.parseError(error).identifier : null;

	const emailUs = useCallback(() => {
		return SupportUtils.contactSupport(
			`Hi, I encountered an error (${identifier}).\n`,
		);
	}, [identifier]);

	const links = isUserLoggedIn() ? (
		<div>
			<Link href={"/home"}>{strings.NAVIGATION_HOME}</Link>
			<Link href={"#"} onClick={signOut}>
				{strings.NAVIGATION_SIGN_OUT}
			</Link>
			<Link href={"#"} onClick={emailUs}>
				{strings.MISC_CONTACT_US}
			</Link>
		</div>
	) : (
		<div>
			<Link href={"/"}>{strings.NAVIGATION_SIGN_IN}</Link>
			<Link href={"#"} onClick={emailUs}>
				{strings.MISC_CONTACT_US}
			</Link>
		</div>
	);

	return (
		<div className={"FatalError StatusPage"}>
			<MiscBackgroundAsset
				className={"StatusPage__bg"}
				alt={"Brightmile-Error"}
			/>
			<ErrorPanel className={"StatusPage__content"} title={null} error={error}>
				<IconBrightMileLogo className={"StatusPage__logo"} />
				<Text tag={"h1"}>{strings.SPLASH_PAGE_UNAVAILABLE_TITLE}</Text>
				<Text tag={"p"} className={"description"}>
					{strings.SPLASH_PAGE_UNAVAILABLE_DESCRIPTION}
				</Text>
				{links}
			</ErrorPanel>
		</div>
	);
};

export default React.memo(FatalError);
